import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Car01 = function Car01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5 13h3M2 9l2 1 1.2706-3.812c.2623-.7867.3934-1.1802.6367-1.471a2 2 0 0 1 .8022-.5782C7.0624 4 7.4771 4 8.3065 4h7.3871c.8294 0 1.244 0 1.5969.1388a2 2 0 0 1 .8022.5782c.2432.2908.3744.6843.6367 1.471L20 10l2-1m-6 4h3M6.8 10h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 12.2798 22 13.1198 22 14.8v2.7c0 .4647 0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714C20.197 20 19.9647 20 19.5 20H19c-1.1046 0-2-.8954-2-2a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5c0 1.1046-.8954 2-2 2h-.5c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C2 18.197 2 17.9647 2 17.5v-2.7c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 10 5.1198 10 6.8 10"
    })
  }));
};
export default Car01;